export default __webpack_public_path__ + "static/media/user review.4e9732da.jpg";